import ModalRedirectToPageWizard from "./modalRedirectToPageWizard";
import { TILDA_PATHS } from "../../../../shared/constants";

export type TModeSellModal = "sell" | "tarde-in";

interface IModalTradeInProps {
  isOpen: boolean;
  offsetY: number;
  onDismiss: (value: boolean) => void;
}

const TEXT_TRADEIN =
  "ТРЕЙД-ИН услуга по обмену вашей квартиры на новую. Перейдите к оформлению заявки и мы поможем подобрать вам новое жилье.";

const TITLE_TRADEIN = "ТРЕЙД-ИН";

const ModalRedirectToPageWizardTradeIn = ({
  isOpen,
  onDismiss,
  offsetY,
}: IModalTradeInProps) => {
  const handleRedirect = () => {
    window.open(TILDA_PATHS.reitInvest.tradeIn, "_blank");
  };

  return (
    <ModalRedirectToPageWizard
      offsetY={offsetY}
      title={TITLE_TRADEIN}
      text={TEXT_TRADEIN}
      onRedirect={handleRedirect}
      onDismiss={onDismiss}
      isOpen={isOpen}
    />
  );
};
export default ModalRedirectToPageWizardTradeIn;
